import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import { useIsomorphicLayoutEffect } from "react-use";
import { createContainer } from "unstated-next";
import { useWindowEventListener } from "~/hooks/listeners";

const useContainer = () => {
  const [sidebarMinimized, setSidebarMinimized] = useState(false);
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = () => setSidebarOpen(false);

    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events, router]);

  useIsomorphicLayoutEffect(() => {
    if (typeof window === "undefined") return;
    if (window.innerWidth >= 1164) return;
    setSidebarMinimized(true);
  }, []);

  useWindowEventListener(
    "resize",
    (e) => {
      if (e.target.innerWidth >= 1164) return;
      setSidebarMinimized(true);
    },
    []
  );

  return {
    sidebarOpen,
    setSidebarOpen,
    sidebarMinimized,
    setSidebarMinimized,
  };
};

const { useContainer: useSideNavigation, Provider: SideNavigationProvider } =
  createContainer(useContainer);

export { useSideNavigation, SideNavigationProvider };
